import { renderTimestamp } from '@/shared/components/tables';

/**
 * Identificatorul „Comandă" din dialogul de respingere (`WasteOrdersReportPage.tsx`).
 *
 * 🔴 De ce exista: `deeeOrderNumber`/`dbaOrderNumber` vin de la ERP, DUPA procesare — o comanda
 * inca in asteptare (exact cele pe care adminul le RESPINGE) nu are niciunul dintre ele. Formula
 * veche, `#${deeeOrderNumber || dbaOrderNumber || 'N/A'}`, arata deci `#N/A` pe orice comanda din
 * fluxul principal al dialogului — un identificator care nu identifica nimic.
 *
 * Cand numarul lipseste, se foloseste un identificator uman: tipul (dedus din `deeeKg`/`dbaKg` —
 * nu exista un camp explicit de tip) + data plasarii (`timestamp`, cu ACELASI `renderTimestamp`
 * pe care il foloseste deja coloana "Data plasare comanda" din tabel, ca cele doua sa nu diverga).
 */
export function eticheteazaComanda(comanda: {
    deeeOrderNumber?: string | null;
    dbaOrderNumber?: string | null;
    deeeKg?: number | null;
    dbaKg?: number | null;
    timestamp?: Date | number | string | null;
}): string {
    const numar = comanda.deeeOrderNumber || comanda.dbaOrderNumber;
    if (numar) return `#${numar}`;

    const areDeee = Boolean(comanda.deeeKg);
    const areDba = Boolean(comanda.dbaKg);
    const tip = areDeee && areDba ? 'DEEE și DBA' : areDeee ? 'DEEE' : areDba ? 'DBA' : null;
    const data = renderTimestamp(comanda.timestamp ?? undefined);

    return tip ? `Comandă ${tip} din ${data}` : `Comandă din ${data}`;
}
